exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-item{padding-right:1rem;padding-left:1rem;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-52c785e2!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FooterBar.vue
// module id = 956
// module chunks = 0